var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 4.66699V12.667C12.6668 13.4035 12.0696 14 11.333 14H4.66699C3.93043 14 3.33318 13.4035 3.33301 12.667V4.66699H12.667ZM6 7.33301V11.333H7.33301V7.33301H6ZM8.66699 7.33301V11.333H10V7.33301H8.66699ZM10 1.33301V2.66699H14V4H2V2.66699H6V1.33301H10Z",
    fill: "#1460AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.b46c3f6e45a1e908b446163c7a9f73eb.svg";
export { ForwardRef as ReactComponent };